module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_null_1@2x.3beb64c3.png";